module.exports = __webpack_public_path__ + "media/images/lp-close-icon@2x-6dac25f554e045820f7b88ca620ea8a6.png";